import axiosInstance from "../../axios/axiosInstance"
import { CreateFollowUpDto, CreateVisitLogDto } from "./visitor-dto"

export class VisitorApi {
    // Visit Log APIs
    static loadVisitLogs = async (page: number = 1, limit: number = 10): Promise<any> => {
        return axiosInstance.get(`/api/visit-logs?page=${page}&limit=${limit}`)
    }
    
    static getVisitLogById = async (id: number): Promise<any> => {
        return axiosInstance.get(`/api/visit-logs/${id}`)
    }
    
    static createVisitLog = async (log: CreateVisitLogDto): Promise<any> => {
        return axiosInstance.post(`/api/visit-logs`, log)
    }
    
    static updateVisitLog = async (id: number, log: CreateVisitLogDto): Promise<any> => {
        return axiosInstance.put(`/api/visit-logs/${id}`, log)
    }
    
    static deleteVisitLog = async (id: number): Promise<any> => {
        return axiosInstance.delete(`/api/visit-logs/${id}`)
    }
    
    static linkVisitWithVehicle = async (visitLogId: number, vehicleLogId: number): Promise<any> => {
        return axiosInstance.post(`/api/visit-logs/link-vehicle`, {
            visit_log_id: visitLogId,
            vehicle_log_id: vehicleLogId
        })
    }
    
    static checkoutVisitor = async (visitLogId: number): Promise<any> => {
        return axiosInstance.post(`/api/visit-logs/${visitLogId}/checkout`)
    }
    
    static getVisitLogsByVisitorId = async (visitorId: number): Promise<any> => {
        return axiosInstance.get(`/api/visit-logs/visitor/${visitorId}`)
    }
    
    static getVisitLogsByMemberId = async (memberId: number): Promise<any> => {
        return axiosInstance.get(`/api/visit-logs/member/${memberId}`)
    }
    
    static getVisitLogsByDateRange = async (startDate: string, endDate: string, page: number = 1, limit: number = 10): Promise<any> => {
        return axiosInstance.get(`/api/visit-logs/date-range?startDate=${startDate}&endDate=${endDate}&page=${page}&limit=${limit}`)
    }
    
    static searchVisitLogs = async (params: {
        visitorId?: number,
        memberId?: number,
        startDate?: string,
        endDate?: string,
        page?: number,
        limit?: number
    }): Promise<any> => {
        const queryParams = new URLSearchParams()
        if (params.visitorId) queryParams.append('visitorId', params.visitorId.toString())
        if (params.memberId) queryParams.append('memberId', params.memberId.toString())
        if (params.startDate) queryParams.append('startDate', params.startDate)
        if (params.endDate) queryParams.append('endDate', params.endDate)
        queryParams.append('page', (params.page || 1).toString())
        queryParams.append('limit', (params.limit || 10).toString())
        
        return axiosInstance.get(`/api/visit-logs/search?${queryParams.toString()}`)
    }
    
    // Legacy endpoints (for backward compatibility)
    static visitorVisitLogsByVisitorId = async (visitorId: number): Promise<any> => {
        return VisitorApi.getVisitLogsByVisitorId(visitorId)
    }
    
    static visitorVisitLogsByMemberId = async (memberId: number): Promise<any> => {
        return VisitorApi.getVisitLogsByMemberId(memberId)
    }
    
    // Visitor APIs
    static visitorList = async (): Promise<any> => {
        return axiosInstance.get(`/api/visitors`)
    }
    
    static updateVisitor = async (visitorId: number, data: any): Promise<any> => {
        return axiosInstance.put(`/api/visitors/${visitorId}`, data)
    }
    
    // Follow-up APIs
    static getFollowups = async (visitor_id: number): Promise<any> => {
        return axiosInstance.get(`/api/visitors/${visitor_id}/follow-ups`)
    }
    
    static createFollowup = async (data: CreateFollowUpDto): Promise<any> => {
        return axiosInstance.post(`/api/visitors/follow-ups`, data)
    }
    
    static updateFollowup = async (followupId: number, data: CreateFollowUpDto): Promise<any> => {
        return axiosInstance.put(`/api/visitors/follow-ups/${followupId}`, data)
    }
    
    // Dashboard/Stats APIs
    static getPendingFollowUps = async (): Promise<any> => {
        return axiosInstance.get(`/api/visit-stats/pending-followups`)
    }
    
    static getDashboard = async (): Promise<any> => {
        return axiosInstance.get(`/api/visit-stats/dashboard`)
    }
}